import React from "react";
import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";
import { Tooltip } from "@mui/material";

function ConsultButton({
    e,
    isEdited,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setRowData,
    setShopId,
    setSale,
    setSelectName,
    setSelectSales,
    setInputSaleMode,
    setLocalFilterActive,
    setIsConsult,
    t,
    setModalState,
    modalState,
}: any) {
    const handleConsultClick = ({
        isEdited,
        setIsActionsClicked,
        setActions,
        setIsEdited,
        setRowData,
        setShopId,
        setSale,
        setSelectName,
        setSelectSales,
        setInputSaleMode,
        setLocalFilterActive,
        setIsConsult,
        selectedRow,
        setModalState,
    }: any) => {
        if (isEdited === true) {
            setIsActionsClicked((prev: any) => !prev);
            setActions(() => {
                setIsEdited(false);
                if (!modalState.isAddModeOfSaleClicked) {
                    setModalState((prev: any) => ({
                        ...prev,
                        isAddModeOfSaleClicked: false,
                    }));
                }
                setRowData(selectedRow);
                setShopId(selectedRow.shopId);
                setSale(selectedRow);
                setSelectName(false);
                setSelectSales(false);
                setInputSaleMode(false);
                setLocalFilterActive(false);
            });
        } else {
            if (!modalState.isAddModeOfSaleClicked) {
                setModalState((prev: any) => ({
                    ...prev,
                    isAddModeOfSaleClicked: false,
                }));
            }
            setRowData(selectedRow);
            setShopId(selectedRow.shopId);
            setSale(selectedRow);
            setSelectName(false);
            setSelectSales(false);
            setInputSaleMode(false);
            setLocalFilterActive(false);
        }
        setIsConsult(true);
    };
    return (
        <Tooltip title={t("To consult")}>
            <div>
                <ConsultSvgIcon
                    className="pointer__clz afa_icn_toConsult"
                    height={35}
                    width={35}
                    style={{
                        cursor: "pointer",
                        position: "relative",
                        bottom: "5px",
                    }}
                    fill="black"
                    onClick={() =>
                        handleConsultClick({
                            isEdited,
                            setIsActionsClicked,
                            setActions,
                            setIsEdited,
                            setRowData,
                            setShopId,
                            setSale,
                            setSelectName,
                            setSelectSales,
                            setInputSaleMode,
                            setLocalFilterActive,
                            setIsConsult,
                            selectedRow: e.selectedRow,
                            setModalState,
                        })
                    }
                />
            </div>
        </Tooltip>
    );
}

export default ConsultButton;
